module.exports = __webpack_public_path__ + "img/callManagement.96697644.png";